/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Ajuste de posición del lector al reenfocar
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Distribución responsiva de preventas
*      4       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Búsqueda multi almacén en preventas
*      5       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Ajuste de distribución lateral en preventas
 *      6       | 26/06/2026 | Lic. José Luis Aragón Cervantes  | Estado compartido para buscador de artículos
 *      7       | 30/08/2026 | Lic. José Luis Aragón Cervantes  | Alt+F12 elimina preventa con confirmación
 * ---------------------------------------------------------------------------------------
*/

import { Fragment, useEffect, useState, useRef, useCallback } from "react";
import { IconButton } from "@mui/material";
import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useFormTabLock } from "../../hooks/useFormTabLock";

import EditIcon from "@mui/icons-material/Edit";

import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas";
import SizeSoftXDetallesVentas from "../leyout/SizeSoftXDetallesVentas";
import SizeSoftXVentasLayout from "../leyout/SizeSoftXVentasLayout";
import SizeSoftXAlert from "../utils/SizeSoftXAlert";
import SizeSoftXLectorCodigoBarras from "../leyout/SizeSoftXLectorCodigoBarras";
import SizeSoftXModal from "../leyout/SizeSoftXModal";

import MnuPreVentasActions from "./MnuPreVentasActions";
import FrmVentasDetalles from "./FrmVentasDetalles";
import ModalEditarPartidasVentas from "./ModalEditarPartidasVentas";
import ModalBuscarArticulosParaVenta from "../herramientas/ModalBuscarArticulosParaVenta";
import ModalFirmaVentas from "./ModalFirmarVentas";
import ModalJalarPreventasCotizaciones from "./ModalJalarPreventasCotizaciones";
import ModalRecuperarPreventas from "./ModalRecuperarPreventas";
import ModalBuscarClientes from "../herramientas/ModalBuscarClientes";
import MnuOtherActionsPreventas from "./MnuOtherActionsPreventas";
import SizeSoftXConfirmDialog from "../leyout/SizeSoftXConfirmDialog";

export default function FrmPreventas() {
  const { isLocked: isFormLocked } = useFormTabLock('preventas', {
    title: 'Preventas',
    onLockDetected: (info) => {
      console.warn(`El formulario de ${info?.title || 'Preventas'} ya está abierto en otra pestaña`);
    }
  });

  const lectorCodigoBarrasRef = useRef(null);
  const panelCodigoBarras = useRef(null);

  const { usuarioData, parametrosCajaForm, handleObtenerParametrosCaja } = useSesion();

  const [usuarioFirmante, setUsuarioFirmante] = useState("");
  const [openModalFirmaJalarPreventaCotizaciones, setOpenModalFirmaJalarPreventaCotizaciones] = useState(false);
  const [openConfirmEliminarPreventa, setOpenConfirmEliminarPreventa] = useState(false);
  const [Talla, setTalla] = useState(0);

  const {
    listaPreventaTemporal,
    partidaSeleccionadaPreventas,
    handleChangePartidaSeleccionadaPreventas,
    handleClickEditarPartidaPreventas,
    handleCerrarModalEditarPartidas,

    handleClickRefrescarDatosPreVenta,
    handleRetotalizarCuentaVenta,
    handleBuscarClienteFromClave,

    openModalPartidas,
    clienteForm,
    ventaTotales,

    handleArirModalBuscarArticulos,
    handleCloseModalBuscarArticulos,

    statusCloseModal,
    handleRegistrarArticuloSubmitPreVenta,

    handleSumarPartidaPreVentas,
    handleRestarPartidaPreVentas,
    handleCambioTipoVenta,
    handleClickEliminarPartidaVentas,

    openModalFirma,
    handleCerrarModalFirmaPreVenta,
    handleFirmarPreventa,

    handleCerrarModalJalarPreVentaCotizacion,
    handleInyectarPreventaCotizacionAVenta,
    openModalJalarPreventaCotizacion,

    // Recuperación
    handleCerrarModalRecuperarPreVenta,
    handleRecuperarPreventas,
    openModalRecuperarPreventa,
    handleAbrirModalRecuperarPreVenta,

    handleCerrarModalRecuperarPreVentaFirma,
    openModalRecuperarPreventaFirma,

    handleClickRegresarMainDashboard,
    handleArirModalFirmaPreVenta,
    handleAbrirModalRecuperarPreVentaFirma,
    handleBuscarArticulos,
    statusKeyActions,
    openModalBuscarArticulosPreventas,
    handleCloseModalBuscarArticulosPreventas,
    handleArirModalBuscarArticulosPreventas,
    handleClickEliminarPreVenta,
    setVentaTotales,
    getVentaTotalesForm,
    setClienteForm,
    handleClickEliminarPartidaPreVentas,
    handleArirModalBuscarCliente,
    handleCerrarModalBuscarCliente,
    openModalBuscarCliente,
    mostrarBuscadorArticulos,
    setMostrarBuscadorArticulos,
  } = useVentas();

  const handleSetTalla = (e) => setTalla(e);

  const focusFiltroBuscadorArticulos = () => {
    setTimeout(() => {
        const filtroInput = document.querySelector('input[name="Filtro"]');
        if (filtroInput) {
            filtroInput.focus();
            filtroInput.select();
        }
    }, 150);
  };

  // =========================
  // Reenfoque lector (centralizado)
  // =========================
  const refocusBarcode = useCallback(() => {
    // primero ancla visual si quieres conservar esa lógica
    panelCodigoBarras.current?.focus?.();

    // luego enfoca el input real del lector
    lectorCodigoBarrasRef.current?.focus?.();
  }, []);

  const refocusBarcodeAsync = useCallback(() => {

    requestAnimationFrame(() => {
      lectorCodigoBarrasRef.current?.focus?.();
    });

    setTimeout(() => {
      lectorCodigoBarrasRef.current?.focus?.();
    }, 0);

    setTimeout(() => {
      lectorCodigoBarrasRef.current?.focus?.();
    }, 80);

    setTimeout(() => {
      lectorCodigoBarrasRef.current?.focus?.();
    }, 180);
  }, []);

  // =========================
  // Wrappers de cierre (cada modal que cierra -> reenfocar)
  // =========================
  const handleCloseBuscarArticulosAndRefocus = useCallback(() => {
    handleCloseModalBuscarArticulosPreventas();
    refocusBarcodeAsync();
  }, [handleCloseModalBuscarArticulos, refocusBarcodeAsync]);

  const handleCloseEditarPartidasAndRefocus = useCallback(() => {
    handleCerrarModalEditarPartidas();
    refocusBarcodeAsync();
  }, [handleCerrarModalEditarPartidas, refocusBarcodeAsync]);

  const handleCloseFirmaPreventaAndRefocus = useCallback(() => {
    handleCerrarModalFirmaPreVenta();
    refocusBarcodeAsync();
  }, [handleCerrarModalFirmaPreVenta, refocusBarcodeAsync]);

  const handleCloseRecuperarPreventaAndRefocus = useCallback(() => {
    handleCerrarModalRecuperarPreVenta();
    refocusBarcodeAsync();
  }, [handleCerrarModalRecuperarPreVenta, refocusBarcodeAsync]);

  const handleCloseRecuperarPreventaFirmaAndRefocus = useCallback(() => {
    handleCerrarModalRecuperarPreVentaFirma();
    refocusBarcodeAsync();
  }, [handleCerrarModalRecuperarPreVentaFirma, refocusBarcodeAsync]);

  // =========================
  // Flujo principal
  // =========================
  const handleRegistrarArticuloCodigoBarras = (data, almacenExhibidor) => {
    setMostrarBuscadorArticulos(false);
    handleRegistrarArticuloSubmitPreVenta(data.codigobarras, almacenExhibidor);
    refocusBarcodeAsync();
  };

  const handleJalarPreventaCotizacion = () => {
    handleInyectarPreventaCotizacionAVenta("PREVENTA");
  };

  const handleFirmarPreventaLista = (vendedorNombre) => {
    if (!vendedorNombre) return;
    const nombre = String(vendedorNombre);
    setUsuarioFirmante(nombre);
    handleFirmarPreventa(parametrosCajaForm.foliopreventa, nombre);
    // cuando se cierre el modal, el wrapper de cierre ya reenfoca
    refocusBarcode();
  };

  const handleCargarVendedorPreventasLista = (vendedorNombre) => {
    if (!vendedorNombre) return;
    setUsuarioFirmante(String(vendedorNombre));
    setOpenModalFirmaJalarPreventaCotizaciones(true);
  };

  const handleAbrirModalRecuperacion = (nombrevendedor) => {
    setUsuarioFirmante(nombrevendedor);
    handleAbrirModalRecuperarPreVenta();
  };

  const ClickEliminarPreVenta = () => {
    handleClickEliminarPreVenta();
    setVentaTotales(getVentaTotalesForm());
    setClienteForm({})
  };

  // =========================
  // Init
  // =========================
  useEffect(() => {
    if (
      parametrosCajaForm.caja === "CAJA-DEFAULT" ||
      parametrosCajaForm.caja === null ||
      parametrosCajaForm.caja === undefined
    ) {
      handleObtenerParametrosCaja();
    }

    handleCambioTipoVenta("PREVENTA");

    handleClickRefrescarDatosPreVenta();
  }, []); // intencional (como lo traías)

  useEffect(() => {
    if (isFormLocked) {
      alert("El formulario de Preventas ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
      setTimeout(() => {
        handleClickRegresarMainDashboard();
      }, 900);
    }
  }, [isFormLocked]);

  useEffect(() => {
    handleRetotalizarCuentaVenta(listaPreventaTemporal);
  }, [listaPreventaTemporal]);

  useEffect(() => {
    // si cambió folio preventa, refresca
    handleCambioTipoVenta("PREVENTA");
    handleClickRefrescarDatosPreVenta();
  }, [parametrosCajaForm.foliopreventa]);

  // =========================
  // Status de cierre global (por si tu contexto lo usa)
  // =========================
  useEffect(() => {
    if (!statusCloseModal) return;
    refocusBarcodeAsync();
    setUsuarioFirmante("");
  }, [statusCloseModal, refocusBarcodeAsync]);

  // Hotkeys específicos de preventas (capture=true)
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key.trim().toUpperCase() === "F4") {
        e.preventDefault();
        e.stopPropagation();
        handleClickRegresarMainDashboard();
      }

      if (e.altKey && e.key === "F10") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();

        if (listaPreventaTemporal.length > 0) {
          handleArirModalFirmaPreVenta();
        }
        return;
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F2") {
        e.preventDefault();
        e.stopPropagation();
        handleArirModalBuscarCliente();
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F1") {
        e.preventDefault();
        e.stopPropagation();
        setMostrarBuscadorArticulos(true);
        handleArirModalBuscarArticulosPreventas();
        focusFiltroBuscadorArticulos();
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F12") {
        e.preventDefault();
        e.stopPropagation();
        setOpenConfirmEliminarPreventa(true);
      }

      if (e.altKey && e.key.trim().toUpperCase() === "F7") {
        e.preventDefault();
        e.stopPropagation();
        handleClickEliminarPartidaPreVentas(partidaSeleccionadaPreventas.idpartida)
      }


      if (e.altKey && e.key.toLowerCase() === "j") {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();

        handleAbrirModalRecuperarPreVentaFirma();
        return;
      }
    };

    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [listaPreventaTemporal.length, handleArirModalFirmaPreVenta, handleAbrirModalRecuperarPreVentaFirma, handleArirModalBuscarCliente, mostrarBuscadorArticulos]);

  useEffect(() => {
    if (statusKeyActions === false) refocusBarcodeAsync();
  }, [statusKeyActions])

  return (
    <>
      <Fragment>
        <SizeSoftXVentasLayout
          titlePage="Módulo de preventas"
          buttonActions={<MnuPreVentasActions />}
          detailComponent={<FrmVentasDetalles />}
        >
          <div className="title-page venta-header-card" style={{ display: 'flex', flexWrap: 'wrap', border: '1px solid #ccc', borderRadius: '4px', padding: '12px', backgroundColor: '#fafafa', gap: '16px' }}>
            <div style={{ minWidth: '150px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CAJA</div>
              <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{parametrosCajaForm.caja}</div>
            </div>
            <div style={{ minWidth: '55px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>TICKET</div>
              <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{parametrosCajaForm.foliopreventa}</div>
            </div>
            <div style={{ minWidth: '90px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>ATENDE</div>
              <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{usuarioData.Usuario}</div>
              <div style={{ fontSize: '11px', color: '#888' }}>{usuarioData.Nombre}</div>
            </div>
            <div style={{ minWidth: '150px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CLIENTE</div>
              <div style={{ fontSize: '14px', fontWeight: 'bold', color: clienteForm.razonsocial ? '#1976d2' : '#999' }}>
                {clienteForm.clavecliente ? `${clienteForm.clavecliente} - ` : ''}{clienteForm.razonsocial || "Sin cliente"}
              </div>
            </div>
            <div style={{ minWidth: '70px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>DESCUENTO</div>
              <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#2e7d32' }}>{clienteForm.porcentajedescuento || 0}%</div>
            </div>
            <div style={{ minWidth: '150px' }}>
              <div style={{ fontSize: '11px', color: '#666', fontWeight: 'bold' }}>CONTACTOS</div>
              <div style={{ fontSize: '12px' }}>{clienteForm.contacto || "-"}</div>
            </div>
          </div>

          <div className="venta-super-container venta-super-container-preventas">
            <div className="venta-super-left-preventas">
              <SizeSoftXTableVentas
                columns={[
                  {
                    hideSort: false,
                    field: "editrow",
                    render: () => (
                      <div>
                        <IconButton onClick={handleClickEditarPartidaPreventas}>
                          <EditIcon color="primary" />
                        </IconButton>
                      </div>
                    ),
                  },
                  { title: "Partida", field: "idpartida" },
                  { title: "Clave artículo", field: "clavearticulo" },
                  { title: "Descripción", field: "descripcion" },
                  { title: "Medida", field: "medida" },
                  { title: "Cantidad artículos", field: "cantidad" },
                  { title: "Costo unitario", field: "costounitario" },
                  { title: "Costo para cliente", field: "costocliente" },
                  { title: "Descuento artículo", field: "descuento" },
                  { title: "Subtotal", field: "subtotal" },
                  { title: "IVA", field: "iva" },
                  { title: "Total", field: "total" },
                  { title: "Origen", field: "almacenexhibidor" },
                  { title: "Folio preventa", field: "foliopreventa" },
                  { title: "Vendedor preventa", field: "vendedorpreventa" },
                ]}
                data={listaPreventaTemporal == null ? [] : listaPreventaTemporal}
                id="idpartida"
                row={partidaSeleccionadaPreventas}
                setRow={handleChangePartidaSeleccionadaPreventas}
                fnDoubleClick={handleClickEditarPartidaPreventas}
                fontSize="small"
                rowsPerPageIntro={50}
              />
            </div>

            <div className="venta-frame-right-preventas" ref={panelCodigoBarras} tabIndex={-1}>
              <div className="venta-super-right-preventas">
                <div className="framelectorcodigosbarras">
                  <SizeSoftXLectorCodigoBarras
                    ref={lectorCodigoBarrasRef}
                    TipoVenta={"PREVENTA"}
                    handleSetCliente={handleBuscarClienteFromClave}
                  />
                </div>
                <SizeSoftXDetallesVentas ventasTotales={ventaTotales} />
              </div>
            </div>
          </div>

          <ModalBuscarArticulosParaVenta
            openModal={mostrarBuscadorArticulos}
            handleCloseModal={() => {
              setMostrarBuscadorArticulos(false);
              handleCloseModalBuscarArticulosPreventas();
              handleCloseBuscarArticulosAndRefocus();
              refocusBarcodeAsync();
            }}
            handleCargarArticulo={handleBuscarArticulos} //Revisar esta rurina por que no se usa 
            dominio={parametrosCajaForm.dominio}
            consultarTodosAlmacenes={true}
            onTallaSelect={handleSetTalla}
            skipFullData={true}
            articuloSelect={handleRegistrarArticuloCodigoBarras}
          />

          <ModalEditarPartidasVentas
            openModal={openModalPartidas}
            rowSelect={partidaSeleccionadaPreventas}
            handleClose={handleCloseEditarPartidasAndRefocus}
            handleEliminar={() => {
              handleClickEliminarPartidaPreVentas(partidaSeleccionadaPreventas?.idpartida);
              handleCerrarModalEditarPartidas();
            }}
            handleSubmitEditarPartidaVentaSumar={handleSumarPartidaPreVentas}
            handleSubmitEditarPartidaVentaRestar={handleRestarPartidaPreVentas}
          />

          <ModalFirmaVentas
            openModalFirmaPreVentas={openModalFirma}
            handleCloseModalFirmaPreVentas={() => {
              handleCloseFirmaPreventaAndRefocus();
              refocusBarcodeAsync();
            }}
            handleFirmarPreventa={handleFirmarPreventaLista}
          />

          <ModalFirmaVentas
            openModalFirmaPreVentas={openModalFirmaJalarPreventaCotizaciones}
            handleCloseModalFirmaPreVentas={() => {
              handleCloseFirmaPreventaAndRefocus();
              refocusBarcodeAsync();
            }}
            handleFirmarPreventa={handleCargarVendedorPreventasLista}
          />

          <ModalJalarPreventasCotizaciones
            openModalJalarPreventaCotizacion={openModalJalarPreventaCotizacion}
            handleCloseModalJalarPreventaCotizacion={() => {
              handleCerrarModalJalarPreVentaCotizacion();
              refocusBarcodeAsync();
            }}
            handleJalarPreventaCotizacion={handleJalarPreventaCotizacion}
            vebdedor={usuarioData.Usuario}
          />

          <ModalRecuperarPreventas
            openModalRecuperarPreventas={openModalRecuperarPreventa}
            handleCloseModalRecuperarPreventas={() => {
              handleCloseRecuperarPreventaAndRefocus();
              refocusBarcodeAsync();
            }}
            handleRecuperarPreventas={handleRecuperarPreventas}
            vendedor={String(usuarioFirmante)}
          />

          <ModalFirmaVentas
            openModalFirmaPreVentas={openModalRecuperarPreventaFirma}
            handleCloseModalFirmaPreVentas={() => {
              handleCloseRecuperarPreventaFirmaAndRefocus();
              refocusBarcodeAsync();
            }}
            handleFirmarPreventa={handleAbrirModalRecuperacion}
          />

          <ModalBuscarClientes
            openModal={openModalBuscarCliente}
            handleCloseModal={handleCerrarModalBuscarCliente}
            onClienteSelect={async (cliente) => {
              await handleBuscarClienteFromClave(cliente.clavecliente);
              handleCerrarModalBuscarCliente();
            }}
          />

          <SizeSoftXConfirmDialog
            open={openConfirmEliminarPreventa}
            title="Eliminar preventa"
            message="¿Desea eliminar toda la preventa actual?"
            handleConfirmDialog={(confirm) => {
              setOpenConfirmEliminarPreventa(false);
              if (confirm) ClickEliminarPreVenta();
            }}
          />

          <SizeSoftXModal />
          <SizeSoftXAlert />
          <MnuOtherActionsPreventas />
        </SizeSoftXVentasLayout>
      </Fragment>
    </>
  );
}

